import { CHANGE_MODE_VIEW } from 'reducers/ui/creativeAssets';

const changeModeView = view => ({
  type: CHANGE_MODE_VIEW,
  view
});

export { changeModeView as default, changeModeView };
